import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterOutlet } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';

import { SidebarComponent } from './core/sidebar/sidebar.component';
import { HeaderComponent } from './core/header/header.component';
import { BreadcrumbService } from './core/services/breadcrumbs.service';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'admin-portal';

  isSpecialRoute: boolean = false;
  breadcrumbs: Array<any> = [];
  private subscriptions = new Subscription();

  public collapsed: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    this.toggleResize();
  }

  toggleResize() {
    this.collapsed = true;
  }

  toggleCollapse(value: boolean) {
    this.collapsed = value;
  }

  constructor(
    private router: Router,
    private breadcrumbService: BreadcrumbService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const specialRoutes = [
          '/login',
          '/forgot-password',
          '/reset-password',
          '/confirm-email-update',
          '/payment-success',
          '/payment-failed'
        ];
        const cleanUrl = this.router.url.split('?')[0];
        this.isSpecialRoute = specialRoutes.includes(cleanUrl);
      }
    });
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.breadcrumbs = this.breadcrumbService.getBreadcrumbs();
        })
    );
  }

  goBack(): void {
    if (this.breadcrumbs.length > 1) {
      const previousBreadcrumb = this.breadcrumbs[this.breadcrumbs.length - 2];
      this.router.navigate([previousBreadcrumb.path]);
    }
  }

  shouldShowBackButton(): boolean {
    return this.breadcrumbs.length > 1;
  }
}
